import {
  getPlants,
  getVariables,
  getMonitorables,
  getTurns,
  getAlerts,
  getSections,
  getMonitorableOfId,
  getSectionOfId
} from "lib/organizationUtils";
import {
  ADD_TURN_TO_STATE,
  ADD_MONITORABLE_TO_STATE,
  CHANGE_CURRENT_ORGANIZATION_INDEX,
  CHANGE_CURRENT_PLANT_INDEX,
  DELETE_TURN_FROM_STATE,
  FETCH_USER_GENERAL_INFO,
  UPDATE_MONITORABLE,
  LOGOUT,
  ADD_INDICATOR_TO_STATE,
  UPDATE_CURRENT_PLANT
} from "../constants/ActionTypes";
import {
  _PENDING,
  _REJECTED,
  _FULFILLED
} from "../constants/PromiseMiddleware";
import clone from "clone";

const defaultStore = {
  isFetching: false,
  currentOrganizationIndex: 0,
  currentPlantIndex: -1, // CurrentPlantIndex == -1. All plants.
  organizations: [],
  organization: {},
  plants: [],
  plant: null,
  additionalMonitorables: [],
  monitorables: [],
  allMonitorables: [], // Not filtered by enabled
  variables: [],
  turns: [],
  sections: [],
  indicators: [],
  allIndicators: [],
  allVariablesDashBoard:[],
};

function refreshState(state, currentOrganizationIndex, currentPlantIndex) {
  const organizations = state.organizations;
  let monitorables = [];
  let variables = [];
  let allVariablesDashBoard = [];

  let plants = [];
  let plant = null;
  let turns = [];
  let currentOrganization;
  let allMonitorables = [];

  if (organizations.length > 0) {
    currentOrganization = organizations[currentOrganizationIndex];
    plants = getPlants(currentOrganization);

    if (currentPlantIndex != -1 && plants.length > 0) {
      plant = plants[currentPlantIndex];
      monitorables = getMonitorables(currentOrganization, plant.id);
    } else {
      monitorables = getMonitorables(currentOrganization, null);
    }
    monitorables = monitorables.concat(
      currentOrganization.additionalMonitorables
    );

    allMonitorables = clone(monitorables);
    monitorables = monitorables.filter(monitorable => monitorable.enabled);

    variables = getVariables(monitorables);

    //fix dashboards widget with variables from other plant
    allMonitorables = getMonitorables(currentOrganization, null);
    allMonitorables = allMonitorables.concat(
      currentOrganization.additionalMonitorables
    );
    allVariablesDashBoard = getVariables(allMonitorables);

    turns = getTurns(currentOrganization);
  }

  if (plants.length === 1) {
    currentPlantIndex = 0;
    plant = plants[currentPlantIndex];
  }

  let indicators = [];

  state.allIndicators.forEach(indicator => {
    if (indicator.organizationId === currentOrganization.id) {
      indicators.push(indicator);
    }
  });

  let sections = getSections(currentOrganization, currentPlantIndex);

  return {
    turns,
    variables,
    monitorables,
    currentPlantIndex,
    sections,
    plants,
    plant,
    organizations,
    indicators,
    allMonitorables,
    organization: currentOrganization,
    allVariablesDashBoard
  };
}

const organizationInfo = (state = defaultStore, action) => {
  let result;
  switch (action.type) {
    case LOGOUT: {
      return defaultStore;
    }

    case CHANGE_CURRENT_ORGANIZATION_INDEX: {
      state.currentPlantIndex = -1;
      result = refreshState(state, action.payload, state.currentPlantIndex);
      return {
        ...state,
        ...result,
        currentOrganizationIndex: action.payload
      };
    }

    case ADD_TURN_TO_STATE: {
      if (action.payload.organizationId === state.organization.id) {
        return { ...state, turns: [...state.turns, action.payload] };
      }

      return { ...state };
    }

    case ADD_MONITORABLE_TO_STATE: {
      let section = getSectionOfId(state.sections, action.payload.section.id);
      action.payload.plant = section.plant;
      action.payload.organization = {
        id: auxState.organization.id,
        name: auxState.organization.name
      };
      return {
        ...state,
        monitorables: [...state.monitorables, action.payload]
      };
    }

    case UPDATE_CURRENT_PLANT:
      let auxState = clone(state);
      let currentPlantId = auxState.plant.id;
      if (action.payload.idMeteoStation) {
        auxState.plant.idMeteoStation = action.payload.idMeteoStation;
       
        for (let i = 0; i < auxState.plants.length; i++) {
          if (auxState.plants[i].id == currentPlantId) {
            auxState.plants[i].idMeteoStation = action.payload.idMeteoStation;
            break;
          }
        }

      }
      if (action.payload.coldReferenceTemperature) {
        auxState.plant.coldReferenceTemperature =
          action.payload.coldReferenceTemperature;
        for (let i = 0; i < auxState.plants.length; i++) {
          if (auxState.plants[i].id == currentPlantId) {
            auxState.plants[i].coldReferenceTemperature = action.payload.coldReferenceTemperature;
            break;
          }
        }
      }
      if (action.payload.hotReferenceTemperature) {
        auxState.plant.hotReferenceTemperature =
          action.payload.hotReferenceTemperature;
        for (let i = 0; i < auxState.plants.length; i++) {
          if (auxState.plants[i].id == currentPlantId) {
            auxState.plants[i].hotReferenceTemperature = action.payload.hotReferenceTemperature;
            break;
          }
        }
      }
      return { ...auxState };

    case UPDATE_MONITORABLE: {
      let auxState = clone(state);

      auxState.monitorables = auxState.monitorables.map(monitorable => {
        if (monitorable.id === action.payload.id) {
          let section = getSectionOfId(
            state.sections,
            action.payload.section.id
          );
          action.payload.plant = section.plant;
          action.payload.organization = {
            id: auxState.organization.id,
            name: auxState.organization.name
          };
          return action.payload;
        } else {
          return monitorable;
        }
      });
      return { ...auxState };
    }

    case DELETE_TURN_FROM_STATE: {
      if (action.payload.idOrganization === state.organization.id) {
        state.turns = state.turns.filter(turn => {
          return turn.id !== action.payload.id;
        });
      }
      return { ...state };
    }

    case ADD_INDICATOR_TO_STATE: {
      if (action.payload.organizationId === state.organization.id) {
        return { ...state, indicators: [...state.indicators, action.payload] };
      }

      return { ...state };
    }

    case ADD_INDICATOR_TO_STATE: {
      if (action.payload.organizationId === state.organization.id) {
        return { ...state, indicators: [...state.indicators, action.payload] };
      }

      return { ...state };
    }

    case CHANGE_CURRENT_PLANT_INDEX: {
      result = refreshState(
        state,
        state.currentOrganizationIndex,
        action.payload
      );
      return { ...state, ...result, currentPlantIndex: action.payload };
    }

    case FETCH_USER_GENERAL_INFO: {
      return { ...state };
    }

    case FETCH_USER_GENERAL_INFO + _PENDING: {
      return { ...state, isFetching: true };
    }

    case FETCH_USER_GENERAL_INFO + _REJECTED: {
      return { ...state, isFetching: false };
    }

    case FETCH_USER_GENERAL_INFO + _FULFILLED: {
      const organizations = action.payload.data.result.organizations;
      const currentOrganizationIndex = state.currentOrganizationIndex;

      // add additional monitorables to orgnaizations
      organizations.forEach(org => {
        const wheatherStations = action.payload.data.result.wheatherStations;
        wheatherStations.forEach(ws => {
          ws.service = "ESTACIONMETEO";
        });

        org.additionalMonitorables = [];
        org.additionalMonitorables = org.additionalMonitorables.concat(
          wheatherStations
        );
      });

      let monitorables = [];
      let variables = [];
      let allVariablesDashBoard=[];
      let plants = [];
      let plant = null;
      let turns = [];
      let currentPlantIndex = -1;
      let allMonitorables = [];
      const currentOrganization = organizations[currentOrganizationIndex];

      let allIndicators = action.payload.data.result.indicators;
      let indicators = [];

      allIndicators.forEach(indicator => {
        if (indicator.organizationId === currentOrganization.id) {
          indicators.push(indicator);
        }
      });

      // get monitorables
      if (organizations.length > 0) {
        plants = getPlants(currentOrganization);

        if (state.currentPlantIndex != -1 && plants.length > 0) {
          plant = plants[state.currentPlantIndex];
          monitorables = getMonitorables(currentOrganization, plant.id);
        } else {
          monitorables = getMonitorables(currentOrganization, null);
        }
        monitorables = monitorables.concat(
          currentOrganization.additionalMonitorables
        );

        allMonitorables = clone(monitorables);
        monitorables = monitorables.filter(monitorable => monitorable.enabled);

        variables = getVariables(monitorables);

        allMonitorables = getMonitorables(currentOrganization, null);
        allMonitorables = allMonitorables.concat(
          currentOrganization.additionalMonitorables
        );
        allVariablesDashBoard = getVariables(allMonitorables);

        turns = getTurns(currentOrganization);
      }

      if (plants.length == 1) {
        currentPlantIndex = 0;
        plant = plants[currentPlantIndex];
      }

      let sections = getSections(currentOrganization, currentPlantIndex);

      return {
        ...state,
        isFetching: false,
        turns,
        variables,
        currentPlantIndex,
        additionalMonitorables: currentOrganization.additionalMonitorables,
        monitorables,
        allMonitorables,
        plants,
        plant,
        sections,
        organizations,
        allIndicators: allIndicators,
        indicators: indicators,
        organization: currentOrganization,
        allVariablesDashBoard
      };
    }
    default: {
      return state;
    }
  }
};

module.exports = organizationInfo;



// WEBPACK FOOTER //
// ./reducers/organizationInfoReducer.js